import { type ReactNode } from 'react';
//import { Navigate } from 'react-router-dom';
//import { useFlagSearch } from '../FeatureFlagsContext';
//import { useQuestEnabled } from '../weddingCountdown';

type QuestRouteProps = {
  children: ReactNode;
};

export function QuestRoute({ children }: QuestRouteProps) {
  //const flagSearch = useFlagSearch();
  //const questEnabled = useQuestEnabled();

  //if (!questEnabled) {
  //  return <Navigate to={{ pathname: '/', search: flagSearch }} replace />;
  //}

  return <>{children}</>;
}
